export const STATUS = Object.freeze({
	TO_BE_AUTHORIZED: 1,
	AUTHORIZED: 2,
	PUBLISHING: 3,
	FILTERING: 4,
	INTERVIEWS: 5,
	FINAL_CANDIDATE: 6,
	OFFER_LETTER: 7,
	ONBOARD: 8,
	PROMOTION: 11,
	AWAITING_PROMOTION: 11,
	//estados final de la vacante
	COMPLETED: 9,
    REJECTED: 10,
	CANCELED: 12,
})
